<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part" id="p01">I The Magic Mountain</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795324857_epub_p01_r1.vue?3811c67c